

const getLang = () => (window.navigator.language || window.navigator.userLanguage).split('-')[0];

export default getLang;